import { ServiceCategoryEntity } from "./service-category-entity";

export class UserServicesInfo {
  serviceCategories: ServiceCategoryEntity[];
  
  constructor(services? : ServiceCategoryEntity[]) {
    this.serviceCategories = services ? JSON.parse(JSON.stringify(services)) : [];
  }
}